import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "../../lib/site";

const WORDS = ["Calm.", "Serenity.", "Elegance.", "Effortless luxury."];

export default function BrandStory() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], ["-6%", "10%"]);
  const y2 = useTransform(scrollYProgress, [0, 1], ["8%", "-8%"]);

  return (
    <section id="story" ref={ref} className="relative bg-warm-white pt-24 pb-12 md:pt-36 md:pb-16">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-14 md:gap-20 items-center">
        {/* Imagery */}
        <div className="relative order-2 md:order-1 h-[460px] md:h-[640px]">
          <motion.div style={{ y: y1 }} className="absolute left-0 top-0 w-[62%] h-[70%] overflow-hidden rounded-sm shadow-[0_30px_60px_-25px_rgba(10,75,84,0.25)]">
            <img src={IMAGES.villaExterior} alt="Mediterranean villa" className="h-full w-full object-cover" />
          </motion.div>
          <motion.div style={{ y: y2 }} className="absolute right-0 bottom-0 w-[54%] h-[62%] overflow-hidden rounded-sm shadow-[0_30px_60px_-25px_rgba(10,75,84,0.25)]">
            <img src="/clean-bench-teal.png" alt="Teal cleaning glove wiping a polished travertine bench with a cloth" className="h-full w-full object-cover" />
          </motion.div>
        </div>

        {/* Copy */}
        <div className="order-1 md:order-2">
          <Reveal><Overline>Our Story</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl leading-tight text-ocean-teal">
              A New Chapter Begins.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 font-sans font-light text-base md:text-lg leading-relaxed text-charcoal/75 max-w-lg">
              Inspired by Galênê, the ancient Greek goddess of calm seas, our name reflects the
              feeling we strive to leave behind in every home.
            </p>
          </Reveal>

          <div className="mt-10 flex flex-wrap gap-x-8 gap-y-3">
            {WORDS.map((w, i) => (
              <Reveal key={w} delay={0.15 + i * 0.08}>
                <span className="font-serif italic text-2xl md:text-3xl text-ocean-teal">{w}</span>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.4}>
            <p className="mt-10 font-sans font-light text-base leading-relaxed text-charcoal/70 max-w-lg">
              What began as a cleaning business has evolved into a boutique brand inspired by
              Mediterranean living, timeless design and exceptional attention to detail.
              <span className="block mt-4 text-charcoal font-normal">Welcome to Casa Galênê. Where luxury meets serenity.</span>
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
